import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { VariedadPeriodoForm, VariedadPeriodoPayload, VariedadPeriodoViewModel } from '../periodos-variedad.types';
import { PeriodosVariedadService } from '../periodos-variedad.service';
import { ActivatedRoute } from '@angular/router';
import { tap, catchError, of } from 'rxjs';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../../../../core/_infrastructure/classes/services/auth.service';
import { DialogComponent } from '../../../../../core/components/dialog/dialog.component';
import { TVariedadViewModel } from '../../../../especies/variedades/variedad.types';
import { DatosPeriodoViewModel } from '../../plazos/plazos.types';
import { PeriodoPlazoService } from '../../plazos/plazos.service';
import { NavMenuService } from '../../../../../core/components/navmenu/navmenu.service';
import { PeriodoCamService } from '../../datosbasicos/periodocam.service';
import { DialogSelectionMode, EnumIdsTcTipoSolicitudCam } from 'src/app/components/_campanias/types/enum';
import { PeriodoCamViewModel } from '../../datosbasicos/periodocam.types';

@Component({
    selector: 'app-periodos-variedad-wrapper',
    templateUrl: './periodos-variedad-wrapper.component.html',
    styleUrls: ['./periodos-variedad-wrapper.component.scss'],
})
export class PeriodosVariedadWrapperComponent extends ComponentBase implements OnInit {
    searching = false;
    variedadesDePeriodo: VariedadPeriodoForm[] = [];
    datosPeriodo: DatosPeriodoViewModel;
    successMessage = 'Datos guardados correctamente';
    messageErrorAlreadyExist = 'Ya existe ésa Variedad en el Periodo. Elimínela de la selección y continue';

    periodoCam: PeriodoCamViewModel;
    esVigenteConSolicitudes = false;

    private periodoId = 0;

    @ViewChild(DialogComponent) private dialogComponent: DialogComponent;
    dialogComponentVisible = false;
    dialogTitle = 'Selecciona la Variedad para el Periodo';
    preSelection: TVariedadViewModel[] = [];

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.periodoId = parseInt(id);
            this.getPeriodoCam(this.periodoId);
            this.getDatosPeriodo(this.periodoId);
            this.getVariedadesDePeriodo();
        } else {
            console.error('Parámetro Id inexistente en la ruta');
        }
    });

    constructor(
        private activatedRoute: ActivatedRoute,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private periodoCamService: PeriodoCamService,
        private periodosVariedadService: PeriodosVariedadService,
        private plazosService: PeriodoPlazoService,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        // no-op
    }

    /**
     * Método que invoca a la API para cargar los datos de un periodo a partir de su id.
     * @param id number
     * @return void
     */
    private getPeriodoCam(id: number): void {
        this.periodoCamService
            .getById(id)
            .pipe(
                tap((p: PeriodoCamViewModel) => {
                    this.periodoCam = p;
                    if (this.esPeriodoFinalizado) {
                        return;
                    }
                    this.getSiVigenteConSolicitudes(id);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    private getDatosPeriodo(id: number): void {
        this.plazosService
            .getDatosPeriodo(id)
            .pipe(
                tap((d: DatosPeriodoViewModel) => {
                    this.datosPeriodo = d;
                    //this.plazosService.datosPeriodo = this.datosPeriodo;
                    this.navMenuService.updateMenuServiceForPeriodo(d.IdPeriodo!);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * It will send the filter to the backend and set the response.
     * @return void
     */
    getVariedadesDePeriodo(): void {
        if (!this.periodoId) {
            return;
        }
        this.periodosVariedadService
            .getVariedadesDePeriodo(this.periodoId)
            .pipe(
                tap((results: VariedadPeriodoViewModel[]) => {
                    this.searching = true;
                    this.variedadesDePeriodo = [];
                    this.updateVariedadesDePeriodo(results);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.searching = false;
                    this.variedadesDePeriodo = [];
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Mostramos la ventana de selección de variedades
     * @return void
     */
    onAdd($event: Event): void {
        $event?.stopPropagation();
        this.onSearchVariedad();
    }

    private updateVariedadesDePeriodo(variedadesDePeriodo: VariedadPeriodoViewModel[] | null): void {
        // Se añaden las variedades seleccionadas al array de variedades de periodo.
        if (!variedadesDePeriodo || variedadesDePeriodo?.length === 0) {
            return;
        }

        const duplicated = this.thereAreNoDuplicates(variedadesDePeriodo);
        if (duplicated) {
            this.addErrorMessage(this.messageErrorAlreadyExist + ': ' + duplicated.Variedad + ' / ' + duplicated.NombreCientifico);
            return;
        }

        variedadesDePeriodo?.forEach(vp => {
            // Al crear el array de nuevo con el spread operator, OnChanges lo detecta.
            this.variedadesDePeriodo = [...this.variedadesDePeriodo, { ...vp, MarkToDelete: false }];
        });
    }

    private thereAreNoDuplicates(variedadesDePeriodoSeleccionadas: VariedadPeriodoViewModel[] | null): VariedadPeriodoForm | null {
        if (variedadesDePeriodoSeleccionadas === null || variedadesDePeriodoSeleccionadas.length === 0) {
            return null;
        }
        let found = null;
        for (let index = 0; index < variedadesDePeriodoSeleccionadas.length && !found; index++) {
            const newVP = variedadesDePeriodoSeleccionadas[index];
            const vp = this.variedadesDePeriodo?.find(vp => vp?.IdVariedad === newVP?.IdVariedad);
            if (vp) {
                found = vp;
            }
        }

        return found;
    }

    /**
     * Se añade la nueva varieddad seleccionada al periodo
     */
    onSave($event: Event): void {
        $event?.stopPropagation();
        // Recorremos la lista de variedades añadidas al periodo y las guardamos
        const vpPayload = this.createPayload();
        if (vpPayload === null || vpPayload?.length === 0) {
            return;
        }
        this.periodosVariedadService
            .saveVariedadesDePeriodo(vpPayload)
            .pipe(
                tap(() => {
                    this.addSuccessMessage(this.successMessage);
                    this.getVariedadesDePeriodo(); // Cargamos de nuevo los datos.
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Creamos el array que se enviará al core para procesar los nuevos elementos o los borrados.
     * @returns VariedadPeriodoPayload[]
     */
    private createPayload(): VariedadPeriodoPayload[] {
        const vpPayload: VariedadPeriodoPayload[] = [];
        this.variedadesDePeriodo?.forEach(vp => {
            if (vp.Id == 0 || vp.MarkToDelete) {
                const variedadPeriodo: VariedadPeriodoPayload = {
                    Id: vp.Id,
                    IdPeriodo: vp.IdPeriodo,
                    IdVariedad: vp.IdVariedad,
                    MarkToDelete: vp.MarkToDelete ? 1 : 0,
                };
                vpPayload.push(variedadPeriodo);
            }
        });
        return vpPayload;
    }

    /**
     * Marcará como borrado o no borrado el elemento en la posición index del array variedadesDePeriodos.
     * Si es un elemento "nuevo" (que no tiene Id), simplemente se borra del array.
     * @param rowIndex number
     * @returns void
     */
    onDelete(rowIndex: number): void {
        if (rowIndex === undefined) {
            return;
        }
        const vp = this.variedadesDePeriodo?.find((value, index) => index === rowIndex);
        if (vp) {
            if (!vp.Id) {
                this.variedadesDePeriodo?.splice(rowIndex, 1);
            } else {
                vp.MarkToDelete = !vp.MarkToDelete;
            }
            // Al crear el array de nuevo con el spread operator, OnChanges lo detecta.
            this.variedadesDePeriodo = [...this.variedadesDePeriodo];
        } else {
            console.error('La variedad-periodo de la posición ', rowIndex, 'no se encuentra');
        }
    }

    /**
     * When the user clicks in the button for searching a "Variedad".
     */
    onSearchVariedad(): void {
        // Doing this we avoid the buscadorvariedad-list to be initiated in first place
        this.dialogComponentVisible = true;
        setTimeout(() => {
            // To give time so the dialog is initialized
            this.dialogComponent.showDialog();
        });
    }

    /**
     * When the user selects "Aceptar" in the dialog, 'accepted' will be true
     * If the user clicks "Cancelar", 'accepted' will be false, in this case the preselection is discarded.
     * @param accepted boolean
     */
    onDialogAccepted(accepted: boolean): void {
        if (!accepted) {
            this.preSelection = [];
            this.dialogComponentVisible = false;
            return;
        }
        this.onSelectVariedad({
            selection: this.preSelection,
            dblclick: true,
        });
    }

    /**
     * When the dialog is opened, a component is injected on it and once data is selected
     * an event is emitted.
     * dblclick equals true: The event is captured and the values are assigned to the form. This event occurs when the user double-click a row in the table-list. The dialog is automatically closed.
     * dblclick equals false: The event is captured and the values are assigned to the preselection. This event occurs when the users clicks a row in the table-list. In this case the dialog must be explicitly closed by the user.
     * @param Object {
     *  selection TVariedadViewModel Element selected in the component embedded in the dialog
     *  dblclick: boolean It indicates if the user has click the row or double-clicked.
     * }
     */
    onSelectVariedad(event$: any): void {
        const selection: TVariedadViewModel = event$.selection;
        const dblclick = event$.dblclick;

        if (!dblclick) {
            // In this case the dialog must be explicitly closed by the user.
            this.preSelection.push(selection);
            return;
        }
        this.dialogComponent.closeDialog();

        let selections: VariedadPeriodoViewModel[] = [];
        this.preSelection.forEach(selection => {
            selections.push({
                Id: 0, // hidden
                IdPeriodo: this.periodoId, // hidden
                IdVariedad: selection.Id!, // hidden
                // The following are read only but will be shown on screen.
                Grupo: selection.Grupo,
                Forma: selection.Forma,
                CodigoEppo: selection.CodigoEppo,
                NombreCientifico: selection.NombreCientifico,
                Variedad: selection.Descripcion,
            });
        });

        this.updateVariedadesDePeriodo(selections);
    }

    /**
     * Se elimina la variedad de la preselección
     * @param deselection TVariedadViewModel
     */
    onUndoSelect(deselection: TVariedadViewModel): void {
        if (!deselection || !this.preSelection) {
            return;
        }
        this.preSelection = this.preSelection.filter(item => item.Id !== deselection.Id);
    }

    /**
     * Método que invoca a la API para comprueba si el periodo es vigente y tiene solicitudes de campaña asociadas.
     * @param id number
     * @return void
     */
    private getSiVigenteConSolicitudes(id: number): void {
        this.periodoCamService
            .getPeriodoEsVigente(id)
            .pipe(
                tap((p: boolean) => {
                    this.esVigenteConSolicitudes = p;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    get formInvalid(): boolean {
        return (
            this.variedadesDePeriodo == null ||
            this.variedadesDePeriodo.length === 0 ||
            this.variedadesDePeriodo.filter(vp => vp.MarkToDelete || vp.Id === 0).length === 0 ||
            this.esPeriodoFinalizado
        );
    }

    get dialogSelectionMode(): string {
        return DialogSelectionMode.Multiple;
    }

    get esPeriodoFinalizado(): boolean {
        const hoy = new Date();
        const fechaFinPeriodo = new Date(this.periodoCam?.FechaFin);
        return hoy >= fechaFinPeriodo;
    }

    /**
     * A partir de la lista de tipos de solicitud del periodo, se comprueba si alguno de ellos es de tipo parcela o invernadero.
     * Si es así, la función devuelve true.
     * Devuelve false en caso contrario.
     * @return boolean
     */
    get periodoHabilitadoParaVariedades(): boolean {
        if (!this.periodoCam || !this.periodoCam.TPeriodoTipoSolicitudCamCollection || this.periodoCam.TPeriodoTipoSolicitudCamCollection?.length === 0) {
            return false;
        }
        let habilitado = false;
        for (let i = 0; i < this.periodoCam.TPeriodoTipoSolicitudCamCollection?.length && !habilitado; i++) {
            const periodoTipo = this.periodoCam.TPeriodoTipoSolicitudCamCollection[i];
            if (
                periodoTipo?.IdTipoSolicitud === EnumIdsTcTipoSolicitudCam.ID_PARCELA ||
                periodoTipo?.IdTipoSolicitud === EnumIdsTcTipoSolicitudCam.ID_INVERNADERO
            ) {
                habilitado = true;
            }
        }
        return habilitado;
    }
}
